import React, { Component, useEffect } from "react";
import Grid from "@material-ui/core/Grid";

import styled from "@emotion/styled";
const MainDiv = styled.div``;
const Card = styled.div`
border:1px solid #ffffff;
`;
const P = styled.p`
    color: #ffffff;
    padding-top: 30px;
  `;
const Features = (props) => {
  return (
    <Grid
      item
      xs={12}
      md={4}
      data-aos="zoom-in"
      data-aos-duration="1300"
      style={{ color: "#ffffff" }}
    >
      <MainDiv className="">
        <Card
          className="p-3 p-sm-5 p-md-4"
          style={{ minHeight: "85px" }}
        >
          <div className="d-flex">
            <img src={props.cardIcon} className="img-fluid" />
            <h5 className=" mt-3 ml-2">
              <b>{props.title}</b><br></br>
            </h5>
          </div>
        </Card>
      </MainDiv>
    </Grid>
  );
};

export default Features;
